"use client";

import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {cn} from "@/lib/utils";
import {
   Collapsible,
   CollapsibleContent,
   CollapsibleTrigger,
} from "@/components/ui/collapsible";
import Icon from "@/components/library/Icon";
import {useWingmanV2Active} from "@/hooks/useWingmanRouting";

type RecalledMemoriesFooterProps = Readonly<{
   facts: string[];
   model?: string | null;
}>;

export default function RecalledMemoriesFooter({facts, model}: RecalledMemoriesFooterProps) {
   const [open, setOpen] = useState(false);
   const {t} = useTranslation("ask");
   const wingmanV2Active = useWingmanV2Active(model);

   if (!wingmanV2Active || facts.length === 0) return null;

   return (
      <Collapsible open={open} onOpenChange={setOpen} className="mt-4 font-source-serif">
         <CollapsibleTrigger
            className="group flex items-center gap-1 text-xs font-medium text-500 hover:text-700 transition-colors cursor-pointer select-none py-2 -my-2 pr-4"
         >
            <Icon
               icon="chevron-right"
               className={cn(
                  "w-3 h-3 transition-transform duration-150",
                  open ? "rotate-90" : "rotate-0"
               )}
            />
            {t("memory.usedFromMemory", {count: facts.length})}
         </CollapsibleTrigger>

         <CollapsibleContent>
            <ul className="mt-1.5 flex flex-col">
               {facts.map((fact, index) => (
                  <li
                     key={`${index}-${fact}`}
                     className="flex items-start gap-2 px-2 py-2 -mx-2 rounded-lg min-w-0"
                  >
                     <span className="inline-flex items-center justify-center w-4 h-4 rounded-md bg-200 text-[10px] font-medium text-500 shrink-0">
                        {index + 1}
                     </span>
                     <span className="min-w-0 text-xs font-medium text-700">{fact}</span>
                  </li>
               ))}
            </ul>
         </CollapsibleContent>
      </Collapsible>
   );
}
